var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 589.324,
    y1: 279.731,
    x2: 632.252,
    y2: 310.183,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    id: "fill0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C9E3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C91AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 588.361,
    y1: 280.915,
    x2: 593.765,
    y2: 290.951,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    id: "fill1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C9E3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C91AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 587.892,
    y1: 291.185,
    x2: 593.629,
    y2: 301.839,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    id: "fill2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C9E3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C91AF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-585 -279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.465 279.472 632.543 279.472 632.543 310.529 589.465 310.529Z",
    stroke: "#464646",
    strokeWidth: 0.914658,
    strokeMiterlimit: 10,
    fill: "url(#fill0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.458 282.478 598.481 282.478 598.481 289.491 585.458 289.491Z",
    stroke: "#464646",
    strokeWidth: 0.914658,
    strokeMiterlimit: 10,
    fill: "url(#fill1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.458 292.496 598.481 292.496 598.481 299.509 585.458 299.509Z",
    stroke: "#464646",
    strokeWidth: 0.914658,
    strokeMiterlimit: 10,
    fill: "url(#fill2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.911 287.939 609.742 287.939 609.742 300.581 615.8 300.581 615.8 302.113 607.911 302.113Z",
    stroke: "#464646",
    strokeWidth: 0.914658,
    strokeMiterlimit: 10,
    fill: "#464646"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogical);
export default __webpack_public_path__ + "static/media/Logical.27134440f7ee066f2ea47862f4147442.svg";
export { ForwardRef as ReactComponent };